import { __assign } from "tslib";
import { COMPONENT_NAME_PREFIX } from '../../constants';
var elementName = COMPONENT_NAME_PREFIX + "select-dropdown";
var observedAttributes = {
    TARGET: 'target',
    SELECTED_TEXT_TARGET: 'selected-text-target',
    SYNC_SELECTED_TEXT: 'sync-selected-text'
};
var attributes = __assign({}, observedAttributes);
var events = {
    SCROLLED_BOTTOM: elementName + "-scrolled-bottom"
};
export var SELECT_DROPDOWN_CONSTANTS = {
    elementName: elementName,
    attributes: attributes,
    events: events
};
